// 1. Content Mapper: Ensures PREVIEW has text/logo defaults
export const mapTenantToLanding_T1 = (tenantData) => {
  return {
    companyId:       tenantData?.companyId,
    branchId:        tenantData?.branchId, 
    userId:          tenantData?.userId,
    logoUrl:         tenantData?.branding?.logoUrl      || '/assets/images/logo.png',
    companyName:     tenantData?.branding?.companyName  || 'Corporate Portal',
    brandName:       tenantData?.branding?.brandName    || 'Corporate Portal',
    email:           tenantData?.branding?.email        || 'support@corporate.com',
    phones:          tenantData?.branding?.phones       || '9177656344',
    socials:         tenantData?.branding?.socials      || {},
    companyData:     tenantData?.companyData || {},
    theme:           tenantData?.theme,
    themeColor1:     tenantData?.theme?.themeColor1,
    headerBgColor:   tenantData?.header?.bgColor,
    headerTextColor: tenantData?.header?.textColor,
    footerBgColor:   tenantData?.footer?.bgColor,
    footerTextColor: tenantData?.footer?.textColor,
    topBarBgColor:   tenantData?.topBar?.bgColor,
    topBarTextColor: tenantData?.topBar?.textColor,

    headerMenu:      Array.isArray(tenantData?.header) ? tenantData?.header : (tenantData?.header?.links || []),
    footerAboutText: tenantData?.footer?.aboutText,
    footerCopyright: tenantData?.footer?.copyright,
    
    heroData:        tenantData?.hero,
    aboutUs:         tenantData?.aboutUs,
    contactUs:       tenantData?.contactUs,
    activeModules:   tenantData?.activeModules,
  };
};

// Function 2: The Color Resolver (Your existing code)
export const getColors_T1 = (landingData) => {
      const headerBg = landingData?.headerBgColor || "#ffffff";

  return {
    theme1: landingData?.themeColor1 || "#2F6F4E", 
    theme2: landingData?.footerBgColor || landingData?.theme?.themeColor2 || "#1a1a1a",
    theme3: landingData?.headerBgColor || landingData?.theme?.themeColor3 || "#ffffff",
    theme4: landingData?.theme?.themeColor4 || "#1f3a5e",
    theme5: landingData?.theme?.themeColor5 || "#ffffff",
    headerText: landingData?.headerTextColor || (headerBg === "#ffffff" ? "#1e293b" : "#ffffff"),
    footerText: landingData?.footerTextColor || "#ffffff",
  };
};